/* ==========================================================================
   With Love Shay Butta — theme JavaScript (vanilla, no dependencies)
   Mobile menu · header search + predictive search · cart drawer (AJAX)
   · product form / variants / gallery · quantity inputs · facets · inquiry prefill
   ========================================================================== */
(function () {
  'use strict';
  var theme = window.theme || { routes: {}, strings: {} };

  /* ---------- helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || theme.moneyFormat || '${{amount}}';
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function trapFocus(container) {
    var focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (!focusable.length) return function () {};
    var first = focusable[0], last = focusable[focusable.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* ---------- mobile menu (native <details>) ---------- */
  function initMobileMenu() {
    var menu = qs('.mobile-menu');
    if (!menu) return;
    var summary = qs('summary', menu);
    function setExpanded() { summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false'); document.body.classList.toggle('menu-open', menu.open); }
    on(menu, 'toggle', setExpanded);
    setExpanded();
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && menu.open) { menu.open = false; summary.focus(); } });
    on(document, 'click', function (e) { if (menu.open && !menu.contains(e.target)) menu.open = false; });
    window.addEventListener('resize', function () { if (window.innerWidth > 900 && menu.open) menu.open = false; });
  }

  /* ---------- header search + predictive search ---------- */
  function initSearch() {
    var toggle = qs('[data-search-toggle]');
    var drawer = qs('[data-search-drawer]');
    if (!toggle || !drawer) return;
    var input = qs('input[type="search"]', drawer);
    var results = qs('[data-predictive-results]', drawer);
    var timer, releaseFocus;

    function openSearch() {
      drawer.classList.add('is-open'); drawer.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      releaseFocus = trapFocus(drawer);
      setTimeout(function () { input.focus(); }, 30);
    }
    function closeSearch() {
      drawer.classList.remove('is-open'); drawer.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      if (releaseFocus) releaseFocus();
    }
    on(toggle, 'click', function () { drawer.classList.contains('is-open') ? closeSearch() : openSearch(); });
    on(qs('[data-search-close]', drawer), 'click', closeSearch);
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) { closeSearch(); toggle.focus(); } });
    on(document, 'click', function (e) { if (drawer.classList.contains('is-open') && !drawer.contains(e.target) && !toggle.contains(e.target)) closeSearch(); });

    if (!results || !theme.routes.predictive_search_url) return;
    on(input, 'input', function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(theme.routes.predictive_search_url + '?q=' + encodeURIComponent(term) + '&resources[type]=product,page,collection,article&resources[limit]=4&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var r = data.resources.results, html = '';
            function group(label, items, render) {
              if (!items || !items.length) return;
              html += '<p class="predictive-label">' + label + '</p>';
              items.forEach(function (i) { html += render(i); });
            }
            group('Products', r.products, function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=88" alt="" loading="lazy">' : '<span class="predictive-thumb"></span>';
              return '<a href="' + p.url + '">' + img + '<span>' + p.title + '</span></a>';
            });
            group('Collections', r.collections, function (c) { return '<a href="' + c.url + '"><span>' + c.title + '</span></a>'; });
            group('Pages', r.pages, function (p) { return '<a href="' + p.url + '"><span>' + p.title + '</span></a>'; });
            group('Articles', r.articles, function (a) { return '<a href="' + a.url + '"><span>' + a.title + '</span></a>'; });
            if (html) html += '<a class="predictive-all" href="' + theme.routes.search_url + '?q=' + encodeURIComponent(term) + '">See all results for “' + term.replace(/</g, '&lt;') + '” →</a>';
            results.innerHTML = html;
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------- quantity inputs ---------- */
  function initQuantity(root) {
    qsa('.quantity', root).forEach(function (q) {
      if (q.dataset.ready) return; q.dataset.ready = '1';
      var input = qs('input', q);
      qsa('button', q).forEach(function (b) {
        on(b, 'click', function () {
          var step = parseInt(input.step || '1', 10);
          var min = parseInt(input.min || '0', 10);
          var val = parseInt(input.value || '0', 10);
          val = b.dataset.action === 'minus' ? Math.max(min, val - step) : val + step;
          if (input.max && val > parseInt(input.max, 10)) val = parseInt(input.max, 10);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- cart drawer ---------- */
  var cart = {
    el: null, releaseFocus: null,
    init: function () {
      this.el = qs('[data-cart-drawer]');
      var self = this;
      qsa('[data-cart-open]').forEach(function (btn) {
        on(btn, 'click', function (e) {
          if (window.theme.cartType === 'page' || !self.el) return;
          e.preventDefault(); self.open();
        });
      });
      if (!this.el) { this.bindPage(); return; }
      this.bind();
      this.bindPage();
      on(document, 'keydown', function (e) { if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close(); });
    },
    bind: function () {
      var self = this;
      qsa('[data-cart-close]', this.el).forEach(function (b) { on(b, 'click', function () { self.close(); }); });
      this.bindLines(this.el);
    },
    bindPage: function () {
      var page = qs('[data-cart-page]');
      if (page) this.bindLines(page);
    },
    bindLines: function (root) {
      var self = this;
      initQuantity(root);
      qsa('[data-line-quantity]', root).forEach(function (input) {
        on(input, 'change', function () { self.change(input.dataset.lineKey, parseInt(input.value, 10), root); });
      });
      qsa('[data-line-remove]', root).forEach(function (btn) {
        on(btn, 'click', function (e) { e.preventDefault(); self.change(btn.dataset.lineKey, 0, root); });
      });
      var note = qs('[data-cart-note]', root);
      if (note) {
        var t;
        on(note, 'input', function () { clearTimeout(t); t = setTimeout(function () {
          fetch(theme.routes.cart_update_url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: note.value }) });
        }, 400); });
      }
    },
    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open'); this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.releaseFocus = trapFocus(qs('.cart-drawer__panel', this.el));
      var close = qs('[data-cart-close]', this.el); if (close) setTimeout(function () { close.focus(); }, 50);
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (this.releaseFocus) this.releaseFocus();
      var opener = qs('[data-cart-open]'); if (opener) opener.focus();
    },
    sectionsToRender: function () {
      var ids = ['cart-drawer'];
      var page = qs('[data-cart-page]'); if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
      var icon = qs('[data-cart-icon-bubble]'); if (icon && icon.dataset.sectionId) ids.push(icon.dataset.sectionId);
      return ids;
    },
    change: function (key, quantity, root) {
      var self = this;
      if (root) root.setAttribute('aria-busy', 'true');
      fetch(theme.routes.cart_change_url, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: this.sectionsToRender().join(','), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data.errors) { self.showError(root, data.errors); if (root) root.removeAttribute('aria-busy'); return; }
        self.renderSections(data.sections);
        if (root) root.removeAttribute('aria-busy');
      }).catch(function () { if (root) root.removeAttribute('aria-busy'); self.showError(root, theme.strings.cartError); });
    },
    add: function (formData, button) {
      var self = this;
      formData.append('sections', this.sectionsToRender().join(','));
      formData.append('sections_url', window.location.pathname);
      var original = button ? button.textContent : '';
      if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = theme.strings.adding; }
      return fetch(theme.routes.cart_add_url, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (button) { button.removeAttribute('aria-disabled'); button.textContent = original; }
          if (data.status) { throw new Error(data.description || data.message || theme.strings.cartError); }
          self.renderSections(data.sections);
          if (window.theme.cartType === 'page' || !self.el) { window.location.href = theme.routes.cart_url; return; }
          self.open();
          if (button) { button.textContent = theme.strings.added; setTimeout(function () { button.textContent = original; }, 1600); }
        });
    },
    renderSections: function (sections) {
      if (!sections) return;
      var self = this;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-drawer' && self.el) {
          var fresh = qs('[data-cart-drawer]', doc);
          var wasOpen = self.el.classList.contains('is-open');
          if (fresh) {
            var body = qs('[data-cart-drawer-content]', self.el), freshBody = qs('[data-cart-drawer-content]', fresh);
            if (body && freshBody) body.innerHTML = freshBody.innerHTML;
            self.bind();
            if (wasOpen) self.releaseFocus = trapFocus(qs('.cart-drawer__panel', self.el));
          }
        } else {
          var target = qs('[data-section-id="' + id + '"]');
          var replacement = qs('[data-section-id="' + id + '"]', doc);
          if (target && replacement) { target.innerHTML = replacement.innerHTML; if (target.hasAttribute('data-cart-page')) self.bindLines(target); }
        }
      });
      qsa('[data-cart-count]').forEach(function (c) {
        var src = qs('[data-cart-count]', new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html'));
        if (src) { c.textContent = src.textContent; c.setAttribute('data-count', src.getAttribute('data-count')); }
      });
    },
    showError: function (root, message) {
      var box = root ? qs('[data-cart-error]', root) : null;
      if (box) { box.textContent = Array.isArray(message) ? message.join(' ') : message; box.hidden = false; }
    }
  };

  /* ---------- product forms (main product + quick add) ---------- */
  function initProductForms() {
    qsa('form[data-product-form]').forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        var button = qs('[type="submit"]', form);
        var err = qs('[data-form-error]', form);
        if (err) { err.hidden = true; err.textContent = ''; }
        cart.add(new FormData(form), button).catch(function (error) {
          if (err) { err.textContent = error.message; err.hidden = false; }
          if (button) { button.removeAttribute('aria-disabled'); button.textContent = theme.strings.addToCart; }
        });
      });
    });
  }

  /* ---------- variant picker ---------- */
  function initVariants() {
    qsa('[data-product-root]').forEach(function (root) {
      var json = qs('[data-product-json]', root);
      if (!json) return;
      var product = JSON.parse(json.textContent);
      var form = qs('form[data-product-form]', root);
      var idInput = qs('input[name="id"]', form);
      var priceEl = qs('[data-product-price]', root);
      var button = qs('[type="submit"]', form);
      var buttonText = qs('[data-add-text]', button) || button;
      var skuEl = qs('[data-product-sku]', root);

      function selectedOptions() {
        var opts = [];
        qsa('.variant-fieldset', root).forEach(function (fs) {
          var checked = qs('input:checked', fs); var select = qs('select', fs);
          opts.push(checked ? checked.value : (select ? select.value : null));
        });
        return opts;
      }
      function findVariant(opts) {
        return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      }
      function updateAvailability(opts) {
        qsa('.variant-fieldset', root).forEach(function (fs, index) {
          qsa('input', fs).forEach(function (input) {
            var test = opts.slice(); test[index] = input.value;
            var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return i === index ? o === test[i] : (opts[i] == null || o === opts[i]); }); });
            var label = qs('label[for="' + input.id + '"]', fs);
            if (label) label.classList.toggle('is-unavailable', !match || !match.available);
          });
        });
      }
      function render() {
        var opts = selectedOptions();
        var variant = findVariant(opts);
        updateAvailability(opts);
        if (!variant) {
          button.setAttribute('disabled', ''); buttonText.textContent = theme.strings.unavailable; return;
        }
        idInput.value = variant.id;
        if (priceEl) {
          var html = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html = '<span class="price-sale">' + formatMoney(variant.price) + '</span><s>' + formatMoney(variant.compare_at_price) + '</s><span class="badge-inline">Sale</span>';
          } else { html = '<span>' + formatMoney(variant.price) + '</span>'; }
          if (variant.unit_price) html += '<span class="unit-price">' + formatMoney(variant.unit_price) + ' / ' + (variant.unit_price_measurement && variant.unit_price_measurement.reference_unit ? variant.unit_price_measurement.reference_unit : '') + '</span>';
          priceEl.innerHTML = html;
        }
        if (skuEl) skuEl.textContent = variant.sku || '';
        if (variant.available) { button.removeAttribute('disabled'); buttonText.textContent = theme.strings.addToCart; }
        else { button.setAttribute('disabled', ''); buttonText.textContent = theme.strings.soldOut; }
        if (variant.featured_media && variant.featured_media.id) showMedia(root, variant.featured_media.id);
        if (window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        var payButton = qs('.shopify-payment-button', root);
        if (payButton) payButton.style.display = variant.available ? '' : 'none';
      }
      qsa('.variant-fieldset input, .variant-fieldset select', root).forEach(function (i) { on(i, 'change', render); });
    });
  }

  /* ---------- product gallery ---------- */
  function showMedia(root, id) {
    qsa('.media-item', root).forEach(function (m) { m.classList.toggle('is-active', String(m.dataset.mediaId) === String(id)); });
    qsa('.gallery-thumbs button', root).forEach(function (b) { b.classList.toggle('is-active', String(b.dataset.mediaId) === String(id)); b.setAttribute('aria-pressed', String(b.dataset.mediaId) === String(id) ? 'true' : 'false'); });
  }
  function initGallery() {
    qsa('[data-product-root]').forEach(function (root) {
      qsa('.gallery-thumbs button', root).forEach(function (b) { on(b, 'click', function () { showMedia(root, b.dataset.mediaId); }); });
    });
  }

  /* ---------- collection facets + sort ---------- */
  function initFacets() {
    var form = qs('[data-facets-form]');
    if (!form) return;
    var sort = qs('[data-sort-by]', form);
    on(sort, 'change', function () { form.submit(); });
    qsa('input[type="checkbox"]', form).forEach(function (c) { on(c, 'change', function () { form.submit(); }); });
    on(document, 'click', function (e) {
      qsa('.facets details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- inquiry form: ?type= prefill (matches original /inquire?type=…) ---------- */
  function initInquiryPrefill() {
    var select = qs('[data-inquiry-interest]');
    if (!select) return;
    var type = new URLSearchParams(window.location.search).get('type');
    if (!type) return;
    var map = { party: 0, parties: 0, bakery: 0, gifting: 1, gift: 1, wholesale: 2, hospitality: 2, product: 3, products: 3 };
    var index = map[type.toLowerCase()];
    if (typeof index === 'number' && select.options.length > index + 1) select.selectedIndex = index + 1;
  }

  /* ---------- search page tabs ---------- */
  function initSearchTabs() {
    var tabs = qsa('[data-search-tab]');
    if (!tabs.length) return;
    tabs.forEach(function (t) {
      on(t, 'click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        qsa('[data-search-panel]').forEach(function (p) { p.hidden = p.dataset.searchPanel !== t.dataset.searchTab; });
      });
    });
  }

  /* ---------- customer address forms ---------- */
  function initAddresses() {
    qsa('[data-address-toggle]').forEach(function (btn) {
      on(btn, 'click', function () { var target = qs('#' + btn.dataset.addressToggle); if (target) target.hidden = !target.hidden; });
    });
    qsa('[data-address-delete]').forEach(function (btn) {
      on(btn, 'click', function () {
        if (!confirm(btn.dataset.confirm || 'Delete this address?')) return;
        var f = document.createElement('form'); f.method = 'post'; f.action = btn.dataset.target;
        f.innerHTML = '<input type="hidden" name="_method" value="delete">'; document.body.appendChild(f); f.submit();
      });
    });
    qsa('[data-country-select]').forEach(function (select) {
      var provinceWrap = qs('#' + select.dataset.provinceWrap);
      var province = provinceWrap ? qs('select', provinceWrap) : null;
      function update() {
        var opt = select.options[select.selectedIndex];
        var provinces = opt ? JSON.parse(opt.getAttribute('data-provinces') || '[]') : [];
        if (!province) return;
        province.innerHTML = '';
        if (!provinces.length) { provinceWrap.hidden = true; return; }
        provinceWrap.hidden = false;
        provinces.forEach(function (p) { var o = document.createElement('option'); o.value = p[0]; o.textContent = p[1]; province.appendChild(o); });
        if (select.dataset.provinceDefault) province.value = select.dataset.provinceDefault;
      }
      if (select.dataset.default) select.value = select.dataset.default;
      on(select, 'change', update); update();
    });
  }

  /* ---------- init ---------- */
  function init() {
    initMobileMenu();
    initSearch();
    initQuantity(document);
    cart.init();
    initProductForms();
    initVariants();
    initGallery();
    initFacets();
    initInquiryPrefill();
    initSearchTabs();
    initAddresses();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor: re-bind when sections are reloaded */
  document.addEventListener('shopify:section:load', function () { initQuantity(document); initProductForms(); initVariants(); initGallery(); cart.init(); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) cart.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) cart.close();
  });
  window.theme.cart = cart;
  window.theme.formatMoney = formatMoney;
})();
